import { env } from "../../env";
import { handleExceptionMessage } from "../../helpers/handleExceptionMessage";
import { instance } from "../axiosInstance";
import {
  CorrectProductionLogRequest,
  GetNestedProductionLogHistoryByLogIdDto,
  GetPlainProductionLogHistoryByLogIdDto,
  ProductionEventsClient,
  ProductionLogDto,
  ProductionSummaryDto,
} from "../httpService";

const http = new ProductionEventsClient(env.REACT_APP_MES_API_URL, instance);

export const getProductionLogByLogId = async (
  logId: string,
  throwError: boolean = true
): Promise<ProductionLogDto | undefined> => {
  try {
    const result = await http.getProductionLogByLogId(logId);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const getCurrentShiftProductionEventsByAssetId = async (
  assetId: string,
  throwError: boolean = true
): Promise<Array<ProductionLogDto> | undefined> => {
  try {
    const result = await http.getProductionEventsByAssetId(assetId);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const getProductionSummaryByAsset = async (
  assetId: string,
  throwError: boolean = true
): Promise<Array<ProductionSummaryDto> | undefined> => {
  try {
    const result = await http.getProductionSummaryByAsset(assetId);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const getPlainProductionEventHistory = async (
  logId: string,
  throwError: boolean = true
): Promise<Array<GetPlainProductionLogHistoryByLogIdDto> | undefined> => {
  try {
    const result = await http.getPlainProductionLogHistoryByLogId(logId);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const getNestedProductionEventHistory = async (
  logId: string,
  throwError: boolean = true
): Promise<GetNestedProductionLogHistoryByLogIdDto | undefined> => {
  try {
    const result = await http.getNestedProductionLogHistoryByLogId(logId);
    return result;
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};

export const correctProductionEvent = async (
  logId: string,
  productionReasonId: string,
  quantityProduced: number,
  comment: string | null = null,
  throwError: boolean = true
): Promise<void> => {
  try {
    const request = new CorrectProductionLogRequest({
      productionReasonId,
      quantityProduced,
      comment,
    });
    await http.correctProductionEvent(logId, request);
  } catch (ApiException) {
    handleExceptionMessage(ApiException);
    if (throwError) throw ApiException;
  }
};
